/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import axios from 'axios'
import store from '../store'
import { getAuthToken } from '@/utils/session'

export const hmsAPI = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL
})

hmsAPI.interceptors.request.use(config => {
  const token = getAuthToken();
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

hmsAPI.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          store.dispatch('notification/error', '401 Unauthorized')
          store.dispatch('clearStore')
          if (process.env.VUE_APP_IS_AAD_LOGIN === 'true') {
            window.location = process.env.VUE_APP_BASE_API_URL + 'login'
          }
          break
        default:
          if (process.env.NODE_ENV !== 'production') {
            store.dispatch('notification/error', `Status code: ${error.response.status}\n${(error.response.data && error.response.data.message) || 'Unknown.\nNo Response Data.'}`)
          }
      }
    } else {
      store.dispatch('notification/error', error.message || 'Unknown Error.')
      console.log('Unknown Error', error)
    }
    return Promise.reject(error)
  }
)

export default axios
